import { render, staticRenderFns } from "./VersionsComparator.vue?vue&type=template&id=3d9e4ea2"
import script from "./VersionsComparator.vue?vue&type=script&lang=js"
export * from "./VersionsComparator.vue?vue&type=script&lang=js"
import style0 from "./VersionsComparator.vue?vue&type=style&index=0&id=3d9e4ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports